<script setup lang="ts">
import type { FilterDropdownProps } from '.';

import { cn } from '@/utils';

import { FilterButton } from '~/components/Filters/FilterButton';

defineOptions({
	inheritAttrs: false
});

const props = withDefaults(defineProps<FilterDropdownProps>(), {
	label: '',
	numberOfAppliedFilters: 0,
	showNumberOfAppliedFilters: true,
	filterButtonVariant: 'default'
});

const attrs = useAttrs();

// Separa o data-test dos demais atributos
const attrsWithoutDataTest = computed(() => {
	const { 'data-test': _, ...rest } = attrs;
	return rest;
});

const dataTestAttr = computed(() => {
	return attrs['data-test'] ? { 'data-test': attrs['data-test'] } : {};
});

const isActive = shallowRef<boolean>(false);

const emit = defineEmits<{
	(e: 'close' | 'open'): void;
}>();

watch(isActive, isOpen => {
	const event = isOpen ? 'open' : 'close';
	emit(event);
});
</script>

<template>
	<DropdownMenu v-model:open="isActive">
		<DropdownMenuTrigger
			v-bind="attrsWithoutDataTest"
			class="relative flex size-min"
			:class="cn('', props.class)"
		>
			<FilterButton
				v-bind="dataTestAttr"
				:is-active="isActive"
				:number-of-applied-filters="numberOfAppliedFilters"
				:show-number-of-applied-filters="showNumberOfAppliedFilters"
				:variant="filterButtonVariant"
				:label="label"
				:class="cn('', props.class)"
			>
				<template #label>
					<slot name="label" />
				</template>
				<template #icon>
					<IconMaterialSymbolsLightExpandMore
						class="size-6 shrink-0 rotate-0 text-beige transition-transform duration-200"
						:class="{ 'rotate-180': isActive }"
					/>
				</template>
			</FilterButton>
		</DropdownMenuTrigger>

		<DropdownMenuContent
			align="start"
			prioritize-position
			class="top-[52px] mt-3 w-[25rem] flex-col overflow-visible border border-white-dark-3 bg-white p-5 text-primary transition-all duration-300 ease-in-out md:top-[58px]"
		>
			<slot name="content" />
		</DropdownMenuContent>
	</DropdownMenu>
</template>
